import { createBrowserHistory } from "history";

import getSearchUrl from "../actions/getSearchUrl";

const deleteParameter = (query, param) => {
	if (null === param) {
		return;
	}

	query.delete(param);
};

const updateParameter = (query, param, value) => {
	if (null === param && null === value) {
		return;
	}
	if (undefined === param || undefined === value) {
		return;
	}

	let values = value.split(",");

	/**
	 * Checken of er meerdere parameters zijn zoals bv. topthema en thema.
	 */
	if (values.length > param.length) {
		query.set(param, values);
	} else {
		query.set(param, value);
	}
};

export default function setSearchUrl(edits) {
	return (dispatch) => {
		var url = window.location.search;
		var query = new URLSearchParams(url);

		for (const [param, value] of Object.entries(edits)) {
			if ("" === value) {
				deleteParameter(query, param);
			} else {
				updateParameter(query, param, value);
			}
		}

		/**
		 * Zet search URL.
		 */
		let history = createBrowserHistory();
		let searchParams = query.toString();
		history.push({
			pathname: "",
			search:
				searchParams.length > 0
					? "?" + searchParams
					: history.replace("/lerarenkaart/alle-voordelen/"),
		});

		dispatch(getSearchUrl());
	};
}
